/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dtp_Sources_NoneInputs */

const vi_dtp_sources_none = /** @type {(inputs: Dtp_Sources_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ kinh doanh`)
};

/**

* @param {Dtp_Sources_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dtp_sources_none = /** @type {((inputs?: Dtp_Sources_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dtp_Sources_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dtp_sources_none(inputs)
});